import { useRef } from 'react'
import { useSelector } from 'react-redux'
import {
  Box,
  Card,
  CardBody,
  CardHeader,
  Stack
} from '@chakra-ui/react'
import { usersSelectors } from 'store'
import { COLORS } from 'utils/styles'

import { RequestItems } from '../RequestItems'

export const FriendRequest = () => {
  const { friendsNotifications } = useSelector(usersSelectors)
  const cardRef = useRef()

  const friendsNotifUnseenCount = () => {
    let unseenCount = 0

    friendsNotifications.forEach((item) => {
      if (!item?.is_viewed) {
        unseenCount += 1
      }
    })

    return unseenCount
  }

  return (
    <Card
      ref={cardRef}
      boxShadow="none"
      marginTop="0px !important"
      background="#c4c3c7"
    >
      <CardHeader
        display="flex"
        alignItems="center"
        padding="0 10px"
        background="#feeb88"
      >
        <Box
          textAlign="left"
          paddingRight="10px"
        >
          Connection Request
        </Box>

        {
          friendsNotifUnseenCount() > 0 && (
            <Stack
              direction="row"
              alignItems="center"
            >
              <Box
                textAlign="center"
                background={COLORS.gold}
                width="17px"
                height="17px"
                borderRadius="full"
                position="relative"
              >
                <Box
                  fontSize="12px"
                  fontWeight={500}
                  transform="translate(-50%, -50%)"
                  top="50%"
                  left="50%"
                  position="absolute"
                >
                  {friendsNotifUnseenCount() > 99 ? '99+' : friendsNotifUnseenCount()}
                </Box>
              </Box>
            </Stack>
          )
        }
      </CardHeader>

      <CardBody
        padding="5px"
        minHeight="130px"
      >
        <Box
          paddingBottom={friendsNotifications.length > 3 ? '5px' : null}
          overflowX="auto"
          display="flex"
          flexDirection="row"
          gap="0px"
          css={{
            '&::-webkit-scrollbar': {
              width: '4px',
              height: '10px',
              display: 'block'
            },
            '&::-webkit-scrollbar-track': {
              width: '6px'
            },
            '&::-webkit-scrollbar-thumb': {
              borderRadius: '24px',
              background: 'rgba(255, 215, 0, 1)'
            }
          }}
        >
          {
            friendsNotifications.length
              ? (
                <RequestItems
                  notificationItems={friendsNotifications}
                  type="archived"
                />
              ) : <div>No notifications to display</div>
          }
        </Box>
      </CardBody>
    </Card>
  )
}
